import styled from "styled-components";

import {
  Input as AntInput,
  Form,
  DatePicker as AntDatePicker,
  Select as AntSelect,
  Row,
  InputNumber as AntInputNumber,
} from "antd";

export const Group = styled.div`
  :first-child {
    margin-top: 42px;
  }
  :last-child {
    margin-bottom: 20px;
  }
  margin-bottom: 30px;
`;
export const GroupLabel = styled.p`
  color: #1070b6;
  font-size: 18px;
  font-weight: bold;
`;

export const Content = styled.div``;

export const Container = styled.div``;

export const Item = styled(Form.Item)`
  :not(:first-child) {
    margin-left: 20px;
  }
  width: 100%;
  .ant-form-item-label label {
    color: #707070;
  }
`;

export const Input = styled(AntInput)`
  width: 100%;
  height: 40px;
  font-size: 16px;
`;

export const InputNumber = styled(AntInputNumber)`
  width: 100%;
  height: 40px;
  font-size: 16px;

  & .ant-input-number-input {
    height: 40px;
  }
`;

export const DatePicker = styled(AntDatePicker)`
  width: 100%;
  height: 40px;
  font-size: 16px;
`;

export const Select = styled(AntSelect)`
  width: 100%;
  height: 40px;
  font-size: 16px;
  div.ant-select-selector {
    height: 40px !important;
    .ant-select-selection-item,
    .ant-select-selection-placeholder {
      line-height: 40px;
      .ant-select-selection-item-content {
        line-height: 22px;
      }
      .ant-select-selection-item-remove {
        line-height: 22px;
      }
    }
  }
`;

export const GroupedRow = styled(Row)`
  align-items: flex-end;
`;
